import { cn } from "@/lib/utils";

import {
  ALL_INTERACTION_TYPES,
  ENTITY_TYPE_LABELS,
  INTERACTION_TYPE_LABELS,
} from "../../constants";
import {
  ENTITY_LABEL_CLASSES,
  ENTITY_ROW_CLASSES,
  ENTITY_TYPES,
} from "../../constants/entities";
import { SandboxEntityType } from "../../types/entities";
import { InteractionType, WeightConfig } from "../../types/interactions";
import WeightCell from "./WeightCell";

const WeightTable = ({
  weights,
  onUpdate,
}: {
  weights: WeightConfig;
  onUpdate: (
    entityType: SandboxEntityType,
    interactionType: InteractionType,
    value: number,
  ) => void;
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr>
            <th className="text-left px-2 py-2 text-xs font-semibold text-foreground w-20 sticky left-0 bg-background">
              Entity
            </th>
            {ALL_INTERACTION_TYPES.map((type) => (
              <th
                key={type}
                className="text-center px-2 py-2 text-xs font-semibold text-foreground whitespace-nowrap"
              >
                {INTERACTION_TYPE_LABELS[type]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ENTITY_TYPES.map((entityType) => (
            <tr
              key={entityType}
              className={cn(
                "border-t border-border",
                ENTITY_ROW_CLASSES[entityType],
              )}
            >
              <td
                className={cn(
                  "px-2 py-1.5 font-semibold text-sm sticky left-0",
                  ENTITY_ROW_CLASSES[entityType],
                  ENTITY_LABEL_CLASSES[entityType],
                )}
              >
                {ENTITY_TYPE_LABELS[entityType]}
              </td>
              {ALL_INTERACTION_TYPES.map((interactionType) => (
                <WeightCell
                  key={interactionType}
                  entityType={entityType}
                  interactionType={interactionType}
                  value={weights[entityType][interactionType] ?? 0}
                  onUpdate={(v) => onUpdate(entityType, interactionType, v)}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-3 text-xs text-muted-foreground">
        Values 0–1. Higher means more influence on the user's taste profile. 0 =
        no effect. Changes apply to all future "Run analysis" calls — existing
        interactions in the list will reflect the new weights immediately.
      </p>
    </div>
  );
};

export default WeightTable;
